import React from 'react';
import PropTypes from 'prop-types';

import capitalize from 'lodash/capitalize';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import i18n from 'i18next';
import sanitizeHtml from 'sanitize-html';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import styles from '../styles/toast.module.scss';

const ICONS = {
  error: ErrorIcon,
  success: CheckCircleIcon,
  warning: InfoIcon,
};

const Toast = ({
  closeToast = () => {},
  data: { body, button, title } = {},
  toastProps: { type } = {},
}) => {
  const Icon = ICONS[type];

  return (
    <div className={styles.element}>
      <div className={styles.inner}>
        {Icon && <Icon className={styles[`is${capitalize(type)}`]} />}
        <div className={styles.content}>
          <div className={styles.text}>
            <Typo>{title}</Typo>
            {body && (
              <Typo
                className={styles.isSecondary}
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(body, { allowedTags: ['a'] }),
                }}
                variant="b01"
              />
            )}
          </div>
          {button && (
            <Button
              className={styles.button}
              size="small"
              text={button.text}
              to={button.to}
              variant="soft"
            />
          )}
        </div>
      </div>
      <Button
        ariaLabel={i18n.t('close', 'Close')}
        icon={<CloseOutlinedIcon />}
        onClick={closeToast}
        size="xsmall"
        variant="ghost"
      />
    </div>
  );
};

Toast.propTypes = {
  closeToast: PropTypes.func,
  data: PropTypes.shape({
    body: PropTypes.string,
    button: PropTypes.shape({
      text: PropTypes.string,
      to: PropTypes.string,
    }),
    title: PropTypes.string,
  }),
  toastProps: PropTypes.shape({
    type: PropTypes.oneOf(['error', 'success', 'warning']),
  }),
};

export default Toast;
